"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _submit = _interopRequireDefault(require("../../../../core/submit"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _input = _interopRequireDefault(require("../../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "What do you want to publish?");
class PublishModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      updating: false,
      list: false,
      notes: false
    });
    _defineProperty(this, "_onSetValue", (value, field) => {
      this.setState({
        [field]: value
      });
    });
    _defineProperty(this, "_onConfirm", async () => {
      if (this.state.list || this.state.notes) {
        this.setState({
          updating: true
        });
        await Promise.all([this.state.list === this.props.competition.displayStartList ? null : this.props.onUpdateCompetition(this.props.competition.id, 'displayStartList', this.state.list), this.state.notes === this.props.competition.displayStartListNotes ? null : this.props.onUpdateCompetition(this.props.competition.id, 'displayStartListNotes', this.state.notes)]);
      }
      this.props.onCloseCancel();
    });
  }
  render() {
    const competition = this.props.competition;
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Publish Start List",
      buttons: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.props.onCloseCancel
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_submit.default, {
        loading: this.state.updating,
        disabled: this.state.loading || !(this.state.notes || this.state.list),
        onClick: this._onConfirm
      }, "Confirm")),
      onClose: this.props.onCloseCancel
    }, _ref, /*#__PURE__*/_react.default.createElement(_input.default, {
      key: "notes",
      type: "Checkbox",
      name: "notes",
      disabled: !competition.startListNotes,
      checked: this.state.notes,
      onChange: this._onSetValue,
      label: /*#__PURE__*/_react.default.createElement("span", {
        className: !competition.startListNotes ? 'read-only' : ''
      }, "Publish Notes")
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      key: "list",
      type: "Checkbox",
      name: "list",
      disabled: !competition.competitionDays.some(day => day.startListRuns.length),
      checked: this.state.list,
      onChange: this._onSetValue,
      label: /*#__PURE__*/_react.default.createElement("span", {
        className: !competition.competitionDays.some(day => day.startListRuns.length) ? 'read-only' : ''
      }, "Publish Start Times")
    }));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(PublishModal, "partialQueries", {
  Competition: {
    id: true,
    startListNotes: true,
    competitionDays: {
      id: true,
      startListRuns: {
        id: true
      }
    }
  }
});
var _default = exports.default = PublishModal;